module.exports = __webpack_public_path__ + "align-left.png?4081d370134c5936eb189157a964dcd7";


//////////////////
// WEBPACK FOOTER
// ./Content/img/align-left.png
// module id = 1016
// module chunks = 1